<template>
    <div class="loader-mask">
        <div class="loader"></div>
    </div>

</template>
  
<script>
export default {
    name: "Loader",
};
</script>
  
<style scoped>
.loader {
    display: inline-block;
    width: 64px;
    height: 64px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
}

.loader:after {
    content: " ";
    display: block;
    width: 40px;
    height: 40px;
    margin: 8px;
    border-radius: 50%;
    border: 6px solid #fff;
    border-color: rgb(var(--v-theme-primary)) transparent rgb(var(--v-theme-primary)) transparent;
    animation: loader 0.7s linear infinite;
}

.loader-mask {
    width: 100%;
    position: absolute;
    height: 100%;
    background: #9d98986e;
    z-index: 9;
    opacity: 0.7;
}

@keyframes loader {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}
</style>